/*
 * AppThemeCssVariables bond setup
 *
 * MODE WIRING ONLY — this file deliberately carries NO palette. The app's
 * colors live in app/src/theme.css (the --mol-color-* / --color-* variables),
 * which overrides anything set here; duplicating a palette in both places is
 * how the page drifts off-brand. See theme.css's header for the palette and
 * its precedence, and DESIGN.md for the brand.
 *
 * What this bond owns: which modes exist, that DARK is the default (the
 * molecule.dev landing is dark-first), and that the choice persists.
 */

import { setProvider } from '@molecule/app-theme'
import {
  createCSSVariablesThemeProvider,
  darkTheme,
  lightTheme,
} from '@molecule/app-theme-css-variables'

export const themeProvider = createCSSVariablesThemeProvider({
  // The base themes from @molecule/app-theme-css-variables are the molecule
  // design system (blue #4070e0 primary). theme.css restamps every variable
  // at CSS time with molecule.dev's exact landing values; these Theme objects
  // only give the provider the mode structure to toggle + persist.
  themes: [lightTheme, darkTheme],
  defaultTheme: 'dark',
  persistKey: 'molecule-theme',
})
export function setupAppThemeCssVariables(): void {
  setProvider(themeProvider)
  // Re-apply the theme to the document. createCSSVariablesThemeProvider
  // applies on construction, and setupAllDefaultBonds() — called first —
  // constructs the default provider, overwriting this one. Re-applying makes
  // this provider's MODE win regardless of order (theme.css keeps the colors).
  themeProvider.setTheme(themeProvider.getTheme())
}
